import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions
} from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { PrimaryButton, RegularButton } from "@components";

import { ContractPriceTemplate_SaveToFavourite, ContractsPriceTemplates } from "@graphql";
import { store } from "@store";
import { ContractPriceTemplateFormInput } from "@config_editor/ContractsPriceTemplates/ContractsPriceTemplateFormInput";

type Props = {
  open: boolean;
  getInput: () => ContractPriceTemplateFormInput;
  onClose: () => void;
};

const AddToFavDialog: React.FC<Props> = ({ onClose, open, getInput }) => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState<boolean>(false);

  const submit = (): void => {
    const input = getInput();
    setLoading(true);
    input.name = name;
    const data = input.getPlain();
    ContractPriceTemplate_SaveToFavourite.func(
      { data },
      {
        refetchQueries: [ContractsPriceTemplates.OperationName]
      }
    )
      .then(() => {
        store().snackbars.success(locale.Saved);
        onClose();
      })
      .catch((e) => {
        setLoading(false);
        store().snackbars.error(`Error: ${e}`);
      });
  };

  const canSubmit = !!name && !loading;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionProps={{ mountOnEnter: true, unmountOnExit: true }}
    >
      <DialogTitle>{locale.Title}?</DialogTitle>

      <DialogContent>
        <TextField
          autoFocus
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          multiline
        />
      </DialogContent>

      <DialogActions>
        <RegularButton variant="text" onClick={onClose}>
          {locale.No}
        </RegularButton>

        <PrimaryButton variant="text" disabled={!canSubmit} onClick={submit}>
          {locale.Save}
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
};

export default AddToFavDialog;
